<template>
    <CChartLine
            :datasets="infoData.datasets"
            :options="defaultOptions"
            :labels="infoData.labels"
    />
</template>

<script>
    import {CChartLine} from '@coreui/vue-chartjs'
    import {getStyle, hexToRgba} from '@coreui/utils/src'

    function random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    export default {
        name: 'MainChartExample',
        components: {
            CChartLine
        },
        props: ['infoData'],
        mounted() {
            const brandInfo = getStyle('info') || '#20a8d8'
            this.infoData[0]['backgroundColor'] = hexToRgba(brandInfo, 10)
        },
        methods: {
            formatMoney(amount, decimalCount = 0, decimal = "", thousands = ",") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            }
        },
        computed: {
            defaultOptions() {
                let self = this;
                return {
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        labels: {
                            fontFamily: "'IRANSans1'",
                            defaultFontSize: 20
                        }
                    },
                    scales: {
                        xAxes: [{
                            gridLines: {
                                drawOnChartArea: false
                            },
                            ticks: {
                                fontFamily: 'IRANSans1'
                            },
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5,
                                fontFamily: 'IRANSans1',
                                callback: function (value, index, values) {
                                    return self.formatMoney(value);
                                }
                            },
                            gridLines: {
                                display: true
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3
                        }
                    }
                }
            }
        }
    }
</script>
